// import { modal } from 'e3-common/core/utils/ui';
import { REGEX } from "../constants/regex";
import { VALIDATION_TYPE } from "../constants/validationType";
import yaml from "js-yaml";

/**
 * @param  {...[ref: ref, label: string, validation: object]} form
 * ref: ref for component
 * label: string
 * validation: validation 정보
 * @returns bool
 */
export const validate = (form) => {
  if (!form) {
    throw new Error("파라미터를 전달해주세요");
  }

  const keys = Object.keys(form);
  if (!keys || !keys.length) {
    throw new Error("파라미터를 전달해주세요");
  }

  for (let i = 0; i < keys.length; i++) {
    const { ref, label, validation } = form[keys[i]];
    if (!validation) {
      continue;
    }

    // 파일 관련 스킵 처리
    if (keys[i].startsWith("fm") || keys[i].startsWith("fs")) {
      continue;
    }

    if (!ref.current) {
      throw new Error(`${i}번째 Control을 찾을 수 없습니다.`);
    }
    if (!label) {
      throw new Error(`${i}번째 Label을 찾을 수 없습니다.`);
    }

    const value = ref.current.getValue();

    const required = validation.required === true ? true : false;

    //rtxt Validation 추가, rtxt가 아닐시 mtxt검사(mtxt는 array)
    if (typeof value === "object" && "startValue" in value) {
      if (required && value["startValue"].length === 0) {
        throw new Error(`${label}: 필수항목입니다.`);
      }
    } else {
      if (Array.isArray(value)) {
        if (value.length == 0) {
          if (required) {
            throw new Error(`${label}: 필수항목입니다.`);
          }
        }
      }
    }

    if (!(value || value === 0)) {
      if (required && !value) {
        throw new Error(`${label}: 필수항목입니다.`);
      }

      if (!required && !value) {
        continue;
      }
    }

    if (validation.type && REGEX[validation.type] && !REGEX[validation.type].test(value)) {
      switch (validation.type) {
        case VALIDATION_TYPE.NUMBER:
          throw new Error(`${label}: 숫자(정수)만 입력해주세요.`);
        case VALIDATION_TYPE.FLOAT:
          throw new Error(`${label}: 숫자(소수점 가능)만 입력해주세요.`);
        case VALIDATION_TYPE.EMAIL:
          throw new Error(`${label}: 이메일 형식으로 입력해주세요.`);
        case VALIDATION_TYPE.PHONE:
          throw new Error(`${label}: '-' 없는 전화번호를 입력해주세요.`);
        case VALIDATION_TYPE.PHONE_WITH_HYPHEN:
          throw new Error(`${label}: '-' 가 포함된 전화번호를 입력해주세요.`);
        case VALIDATION_TYPE.BIRTHDAY:
          throw new Error(`${label}: '-' 없는 생년월일을 입력해주세요.`);
        case VALIDATION_TYPE.BIRTHDAY_WITH_HYPHEN:
          throw new Error(`${label}: '-' 가 포함된 생년월일을 입력해주세요.`);
        case VALIDATION_TYPE.TIME_HHMM:
          throw new Error(`${label}: 시간의 형식이 잘못되었습니다.`);
        case VALIDATION_TYPE.THOUSAND_COMMA:
          throw new Error(`${label}: 천단위로 ',' 가 포함된 숫자를 입력해주세요.`);
        case VALIDATION_TYPE.IP:
          throw new Error(`${label}: IP 주소형식이 잘못되었습니다.`);
      }
    }

    if (validation.type === VALIDATION_TYPE.NUMBER || validation.type === VALIDATION_TYPE.FLOAT) {
      let numberValue = 0;
      try {
        numberValue = parseFloat(value);
      } catch (ex) {
        throw new Error(`${label}: 숫자를 입력해주세요.`);
      }

      if (validation.minMaxRange) {
        if (validation.minMaxRange.min !== null && validation.minMaxRange.min !== undefined) {
          let min = 0;
          try {
            min = parseFloat(validation.minMaxRange.min);
          } catch (e) {
            throw new Error(`${label}: min값 지정이 잘못되었습니다.`);
          }
          if (numberValue < min) {
            throw new Error(`${label}: 값이 최소값 ${min}보다 작습니다.`);
          }
        }
        if (validation.minMaxRange.max !== null && validation.minMaxRange.max !== undefined) {
          let max = 0;
          try {
            max = parseFloat(validation.minMaxRange.max);
          } catch (e) {
            throw new Error(`${label}: max값 지정이 잘못되었습니다.`);
          }
          if (numberValue > max) {
            throw new Error(`${label}: 값이 최대값 ${max}보다 큽니다.`);
          }
        }
      }
    }

    if (validation.lengthRange) {
      if (validation.lengthRange.min !== null && validation.lengthRange.min !== undefined) {
        let min = 0;
        try {
          min = parseInt(validation.lengthRange.min);
        } catch (e) {
          throw new Error(`${label}: 최소길이 지정이 잘못되었습니다.`);
        }
        if (value.length < min) {
          throw new Error(`${label}: 길이가 최소길이 ${min}보다 작습니다.`);
        }
      }
      if (validation.lengthRange.max !== null && validation.lengthRange.max !== undefined) {
        let max = 0;
        try {
          max = parseInt(validation.lengthRange.max);
        } catch (e) {
          throw new Error(`${label}: 최대길이 지정이 잘못되었습니다.`);
        }
        if (value.length > max) {
          throw new Error(`${label}: 길이가 최대길이 ${max}보다 큽니다.`);
        }
      }
    }
  }

  return true;
};

/**
 * YAML 파일을 JavaScript 객체로 변환
 * @param {*} ymlFile 유효성 체크 YAML 파일
 * @returns
 */
export const getObjectFromYml = async (ymlFile) => {
  try {
    const ymlFetch = await fetch(ymlFile);
    const text = await ymlFetch.text();
    const data = await yaml.load(text);
    return data;
  } catch (error) {
    console.error("YAML 파일을 읽을 수 없습니다.", error);
    return null;
  }
};

/**
 * validate()에서 요구하는 파라메터 형식으로 맞춤
 * @param {*} serverYmlFile 서버용 validate yml
 * @returns
 */
export const getValidateObject = (validInfo, colName, value) => {
  validInfo.type =
    validInfo.type.search(/[a-z]/g) < 0
      ? validInfo.type
      : validInfo.type
          .replace(/[A-Z]/g, (letter) => `_${letter.toUpperCase()}`)
          .replace(/[a-z]/g, (letter) => `${letter.toUpperCase()}`);

  let formObject = new Object();
  let controlObject = new Object();
  let refObject = new Object();

  class Current {
    constructor(value) {
      this.value = value;
    }
    getValue() {
      return value;
    }
    setValue(val) {
      this.value = val;
    }
  }

  refObject.current = new Current(value);
  controlObject.ref = refObject;
  controlObject.label = colName;
  controlObject.validation = validInfo;
  formObject.control = controlObject;

  return formObject;
};
